"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _icon = _interopRequireDefault(require("../../icon"));
var _Collapse = _interopRequireDefault(require("../Collapse"));
var _CollapseItem = _interopRequireDefault(require("../CollapseItem"));
var _CollapseItemTitle = _interopRequireDefault(require("../CollapseItemTitle"));
var _CollapseItemBody = _interopRequireDefault(require("../CollapseItemBody"));
var _VirtualizedList = _interopRequireDefault(require("./VirtualizedList"));
var _FilterCollapseItem = _interopRequireDefault(require("./FilterCollapseItem"));
var _FilterCollapse = _interopRequireDefault(require("./FilterCollapse.style"));
var _constants = require("./constants");
var _excluded = ["onToggle", "titleProps", "bodyProps", "multipleOpen", "classPrefix", "items", "selectedItems", "virtualized", "onChange"],
  _excluded2 = ["toggle", "openItems"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var FilterCollapse = /*#__PURE__*/function (_Component) {
  function FilterCollapse(props) {
    var _this;
    _classCallCheck(this, FilterCollapse);
    _this = _callSuper(this, FilterCollapse, [props]);
    _this.elemRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      listHeight: null
    };
    return _this;
  }
  _inherits(FilterCollapse, _Component);
  return _createClass(FilterCollapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        listHeight: R.path(['current', 'offsetHeight'], this.elemRef) - _constants.OFFSET
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onToggle = _this$props.onToggle,
        titleProps = _this$props.titleProps,
        bodyProps = _this$props.bodyProps,
        multipleOpen = _this$props.multipleOpen,
        classPrefix = _this$props.classPrefix,
        items = _this$props.items,
        selectedItems = _this$props.selectedItems,
        virtualized = _this$props.virtualized,
        onChange = _this$props.onChange,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var listHeight = this.state.listHeight;
      return /*#__PURE__*/_react["default"].createElement(_FilterCollapse["default"], {
        ref: this.elemRef,
        classPrefix: classPrefix
      }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], _extends({
        classPrefix: classPrefix,
        items: items,
        multi: multipleOpen
      }, otherProps), function (_ref) {
        var toggle = _ref.toggle,
          openItems = _ref.openItems,
          other = _objectWithoutProperties(_ref, _excluded2);
        return items.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement(_CollapseItem["default"], _extends({
            key: item.title
          }, other), /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_CollapseItemTitle["default"], _extends({
            onClick: R.compose(onToggle, function () {
              return toggle(index);
            })
          }, titleProps, other), openItems.includes(index) ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            className: "button-icon",
            size: 14,
            icon: "ion-chevron-down"
          }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            className: "button-icon",
            size: 14,
            icon: "ion-chevron-right"
          }), /*#__PURE__*/_react["default"].createElement("span", null, item.title)), openItems.includes(index) && /*#__PURE__*/_react["default"].createElement(_CollapseItemBody["default"], _extends({}, bodyProps, other), /*#__PURE__*/_react["default"].createElement("ul", null, virtualized ? /*#__PURE__*/_react["default"].createElement(_VirtualizedList["default"], {
            item: item,
            listHeight: listHeight
          }, function (_ref2) {
            var idx = _ref2.idx,
              subItem = _ref2.subItem,
              style = _ref2.style;
            return /*#__PURE__*/_react["default"].createElement(_FilterCollapseItem["default"], {
              key: "".concat(idx).concat(item.title).concat(subItem.value),
              item: item,
              subItem: subItem,
              selectedItems: selectedItems,
              virtualized: virtualized,
              onChange: onChange,
              style: style
            });
          }) : R.map(function (subItem) {
            return /*#__PURE__*/_react["default"].createElement(_FilterCollapseItem["default"], {
              key: "".concat(item.key).concat(item.title).concat(R.prop('value', subItem)),
              item: item,
              subItem: subItem,
              selectedItems: selectedItems,
              virtualized: virtualized,
              onChange: onChange
            });
          }, item.list)))));
        });
      }));
    }
  }]);
}(_react.Component);
FilterCollapse.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    list: _propTypes["default"].arrayOf({})
  })).isRequired,
  selectedItems: _propTypes["default"].shape({}),
  onChange: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  multipleOpen: _propTypes["default"].bool,
  classPrefix: _propTypes["default"].string,
  titleProps: _propTypes["default"].shape({}),
  bodyProps: _propTypes["default"].shape({}),
  virtualized: _propTypes["default"].bool
};
FilterCollapse.defaultProps = {
  onChange: _utils.noop,
  onToggle: _utils.noop,
  multipleOpen: true,
  classPrefix: 'FilterCollapse',
  titleProps: {},
  bodyProps: {},
  selectedItems: {},
  virtualized: false
};
var _default = exports["default"] = FilterCollapse;